(function () {
  var KEY = "mp24-audience";

  function audience() {
    return document.documentElement.getAttribute("data-mp-audience") || "private";
  }

  function paint() {
    var biz = audience() === "business";
    document.querySelectorAll("[data-mp-money]").forEach(function (el) {
      var text = biz ? el.getAttribute("data-mp-net-text") : el.getAttribute("data-mp-gross-text");
      if (text) el.textContent = text;
    });
    document.querySelectorAll("[data-mp-vat-label]").forEach(function (el) {
      el.textContent = biz
        ? el.getAttribute("data-biz") || "zzgl. MwSt."
        : el.getAttribute("data-priv") || "inkl. MwSt.";
    });
  }

  function syncButtons(value) {
    document.querySelectorAll("[data-audience]").forEach(function (btn) {
      btn.classList.toggle("is-active", btn.getAttribute("data-audience") === value);
    });
  }

  window.mp24SetAudience = function (value) {
    if (value !== "private" && value !== "business") return;
    document.documentElement.setAttribute("data-mp-audience", value);
    try {
      localStorage.setItem(KEY, value);
    } catch (err) {}
    syncButtons(value);
    paint();
    document.dispatchEvent(new CustomEvent("mp24-audience", { detail: value }));
  };

  function bindButtons() {
    document.querySelectorAll("[data-audience]").forEach(function (btn) {
      if (btn.dataset.mpVatBound) return;
      btn.dataset.mpVatBound = "1";
      btn.addEventListener("click", function () {
        window.mp24SetAudience(btn.getAttribute("data-audience"));
      });
    });
  }

  function boot() {
    var saved = null;
    try {
      saved = localStorage.getItem(KEY);
    } catch (err) {}
    if (saved === "private" || saved === "business") {
      document.documentElement.setAttribute("data-mp-audience", saved);
    } else if (!document.documentElement.getAttribute("data-mp-audience")) {
      document.documentElement.setAttribute("data-mp-audience", "private");
    }
    bindButtons();
    syncButtons(audience());
    paint();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  document.addEventListener("cart:updated", function () {
    bindButtons();
    paint();
  });

  var timer = null;
  new MutationObserver(function () {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      bindButtons();
      paint();
    }, 40);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
